import { useLocalization } from '@ais-ui/locale-management';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import React from 'react';
import { cn } from '@ais-ui/utils';
import {
  Card,
  CardClose,
  CardContent,
  CardHeader,
  CardTitle,
  InfoIconTooltip,
  Separator,
} from '@ais-ui/ui-core';
import { Replay } from './Replay';
import { ReplayVideo } from './ReplayVideo';

interface ReplaysProps {
  className: string;
}

export const Replays = ({ className }: ReplaysProps) => {
  const { messages } = useLocalization();
  const onExit = useOnMapPanelExit();

  return (
    <Card className={cn('w-[560px] h-[320px]', className)}>
      <CardHeader className="flex flex-row items-start gap-2">
        <CardClose onClick={() => onExit()} />
        <CardTitle className="text-lg font-medium text-muted-foreground">
          {messages.replayTitle}
        </CardTitle>
        <InfoIconTooltip>{messages.replayStartInfoIcon}</InfoIconTooltip>
      </CardHeader>
      <CardContent className="space-y-4">
        <Separator className="-mt-4"></Separator>
        <ReplayVideo></ReplayVideo>
        <Separator></Separator>
        <Replay></Replay>
      </CardContent>
    </Card>
  );
};
